import React, { useEffect, useState } from "react";
import { Share, Plus, X } from "lucide-react";

export default function IOSInstallBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = localStorage.getItem("fripri_ios_install_dismissed");
    if (dismissed) return;
    const ua = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isInStandalone = window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches ||
      !!window.webkit?.messageHandlers;
    if (isIOS && !isInStandalone) {
      const t = setTimeout(() => setShow(true), 3000);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem("fripri_ios_install_dismissed", "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-[88px] md:bottom-6 left-3 right-3 md:left-auto md:right-6 md:w-80 z-50 bg-white border-2 border-black shadow-[6px_6px_0_0_#000] slide-up" data-testid="ios-install-banner">
      <div className="p-4">
        <div className="flex items-start gap-3">
          <div className="w-12 h-12 flex items-center justify-center shrink-0 overflow-hidden">
            <img src="/logo-fripri.svg" alt="Fripri" className="w-full h-full object-contain" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-black text-sm">Installe Fripri sur ton iPhone</p>
            <p className="text-xs text-[color:var(--color-text-muted)] mt-1">Reçois les notifs en temps réel, comme une vraie app.</p>
            <div className="mt-2 text-xs space-y-1.5">
              <div className="flex items-center gap-1.5"><Share size={14} strokeWidth={2.5}/> 1. Tape sur Partager</div>
              <div className="flex items-center gap-1.5"><Plus size={14} strokeWidth={2.5}/> 2. "Sur l'écran d'accueil"</div>
            </div>
          </div>
          <button onClick={dismiss} className="text-[color:var(--color-text-muted)]" data-testid="ios-install-dismiss" aria-label="Fermer"><X size={18}/></button>
        </div>
      </div>
    </div>
  );
}
